import { useEffect, useRef, useState } from "react";
import { getWorkflowIdentity } from "./workflow-api";
import { portalLinksForIdentity } from "./portal-navigation";
import { reviewerPreviewSandboxEnabled } from "./auth";

export default function PortalNavigation({ getAccessToken, current = "studio" }) {
  const [identity, setIdentity] = useState(null);
  const tokenProvider = useRef(getAccessToken);
  tokenProvider.current = getAccessToken;

  useEffect(() => {
    let active = true;
    getWorkflowIdentity(() => tokenProvider.current())
      .then((result) => { if (active) setIdentity(result.identity); })
      .catch(() => { if (active) setIdentity(null); });
    return () => { active = false; };
  }, []);

  const links = portalLinksForIdentity(identity, current, { reviewerPreviewSandboxEnabled });
  if (!links.length) return null;
  return <nav className="portal-navigation" aria-label="Authorized workspaces">
    {links.map((link) => <a key={link.id} href={link.href}>{link.label}</a>)}
  </nav>;
}
